import type { TFunction } from '~/core/i18n'

type SearchInputPlaceholder = {
  t: TFunction
  tvEnabled: boolean
  vodEnabled: boolean
  tvShowEnabled: boolean
  eventsEnabled: boolean
}

export const formatSearchInputPlaceholder = ({
  t,
  tvEnabled,
  vodEnabled,
  tvShowEnabled,
  eventsEnabled,
}: SearchInputPlaceholder): string => {
  const placeholderString: string[] = []

  if (tvShowEnabled) {
    placeholderString.push(t('series'))
  }

  if (vodEnabled) {
    placeholderString.push(t('movies'))
  }

  if (tvEnabled) {
    placeholderString.push(t('live_channels'))
  }

  if (eventsEnabled) {
    placeholderString.push(t('event_other'))
  }

  return placeholderString.join(', ').replace(/,\s*$/, '')
}
